import AddCircleIcon from '@mui/icons-material/AddCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import { TableRow, Stack, TableCell, IconButton } from '@mui/material'
import { Field } from 'components/DocumentDetail/types'
import FormInput from 'components/ui/FormInput'
import { DocumentInvoiceV2JSON } from 'entities/DocumentsInvoiceV2'
import { useHighlightContext } from 'hooks/useHighlightContext'
import { useFormContext } from 'react-hook-form'
import applyErrorMsg from 'utils/applyErrorMsg'

import { ITEM_KEYS } from './common'
import ItemCell from './ItemCell'

interface Props {
  id: string
  editId: string | undefined
  editIdx: number
  fieldsConfig: Field[] | undefined
  defaultValues: any
  onDel: () => void
  onAdd: () => void
  canEdit: boolean
  isChecking: boolean
  config: DocumentInvoiceV2JSON['config']
}

const ItemRow: React.FC<Props> = ({
  editIdx,
  id,
  editId,
  fieldsConfig,
  defaultValues,
  onDel,
  onAdd,
  canEdit,
  isChecking,
  config,
}: Props) => {
  const { update: updateHL } = useHighlightContext()
  const visibleItems = ITEM_KEYS.filter((key) => config.itemLines[key]?.display || false)

  const docDisabled = !canEdit
  const { setValue } = useFormContext()

  const itemCells = ITEM_KEYS.map((name) => {
    const uneditable = (config.itemLines?.[name]?.edit || false) === false
    const foundField = fieldsConfig?.find((x) => x.name === name)
    const compProps = {
      ...foundField?.compProps,
      disabled: uneditable || docDisabled || foundField?.compProps?.disabled,
    }
    // if it is itemName, inject rule to be required
    const rules = applyErrorMsg(
      foundField?.rules || (name === 'itemName' ? { required: true } : undefined),
    )
    const field = { ...foundField, rules, compProps }
    const hidden =
      !visibleItems.includes(name) || (isChecking && config.itemLines?.[name]?.verify === false)

    if (hidden) {
      return null
    }
    if (name === 'expenseTypeCode') {
      compProps.onChange = (name: string, value: string) => {
        // custom すぎるが... nameとvalueをもらう必要がある
        setValue(`${name}Dumb`, value)
      }
    }
    return (
      <ItemCell
        {...field}
        key={name}
        name={`itemLines[${editIdx}].${name}`}
        testid={`${field.testid}${editIdx}`}
        defaultValue={defaultValues[name]}
        onFocus={() => updateHL(`${id}.${name}\\.`)}
      />
    )
  })

  return (
    <TableRow
      sx={{
        '&:hover .MuiStack-root': {
          visibility: 'visible',
        },
      }}
    >
      <TableCell padding="none">
        {!docDisabled && (
          <Stack sx={{ ml: 1, visibility: 'hidden' }}>
            <IconButton size="small" onClick={onDel} sx={{ p: 0.7, pb: 0.4 }}>
              <RemoveCircleIcon fontSize="small" color={docDisabled ? 'disabled' : 'error'} />
            </IconButton>
            <IconButton size="small" onClick={onAdd} sx={{ p: 0.7, pt: 0.4 }}>
              <AddCircleIcon fontSize="small" color={docDisabled ? 'disabled' : 'primary'} />
            </IconButton>
          </Stack>
        )}
        <span style={{ display: 'none' }}>
          <FormInput
            type="number"
            name={`itemLines[${editIdx}].order`}
            defaultValue={editIdx + 1}
          />
          <FormInput type="text" name={`itemLines[${editIdx}].id`} defaultValue={id || editId} />
        </span>
      </TableCell>
      {itemCells}
    </TableRow>
  )
}

export default ItemRow
